import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import React from "react";

export default function QRCodeCarousel() {
  return (
    <div className="w-full text-center py-6 px-4 bg-white">
      <h3
        style={{
          transform: "scaleY(1.2)",
        }}
        className="uppercase text-[#234042] text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[69px] leading-[1.2] text-left  mb-4 mt-4 ml-4"
      >
        Built-in{" "}
        <span
          className="text-white font-[Bebas Neue] tracking-[2px] uppercase"
          style={{
            WebkitTextStroke: "1px #F47321",
          }}
        >
          QR CODE
        </span>
        <br />
        Generators Simplified
      </h3>

      <img src="/images/4308850 1.svg"  className="w-full max-w-md mx-auto" />

      {/* <Carousel
        autoPlay
        infiniteLoop
        interval={2000}
        showThumbs={false}
        showArrows={false}
        showStatus={false}
        swipeable={true}
        className="w-full max-w-md mx-auto"
      >
        <div><img src="/images/4308850 1.svg" alt="QR 1" /></div>
        <div><img src="/images/4308850 1.svg" alt="QR 2" /></div>
        <div><img src="/images/4308850 1.svg" alt="QR 3" /></div>
      </Carousel> */}
    </div>
  );
}
